// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default class Deferred<T> {
    #promise: Promise<T>;

    resolve!: (value?: (PromiseLike<T> | T)) => void;

    reject!: (reason?: any) => void;

    then: <TResult1 = T, TResult2 = never>
    (onfulfilled?: (((value: T) =>
        (PromiseLike<TResult1> | TResult1)) | undefined | null), onrejected?:
         (((reason: any) => (PromiseLike<TResult2> | TResult2)) | undefined | null)) =>
        Promise<TResult1 | TResult2>;

    catch: <TResult = never>(onrejected?: (((reason: any) =>
        (PromiseLike<TResult> | TResult)) | undefined | null)) => Promise<T | TResult>;

    constructor() {
      this.#promise = new Promise((resolve, reject) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.resolve = resolve;
        this.reject = reject;
      });

      this.then = this.#promise.then.bind(this.#promise);

      this.catch = this.#promise.catch.bind(this.#promise);
    }
}
